import React from 'react'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import DonatePage from './components/DonatePage'
import { LANGUAGE_SHORT_CODE } from '../../constants';
import { WID } from '../../constants/Language';
import Word from '../../containers/Common/Word';
import { MenuAppBar } from '../../Parts/MenuAppBar'

class DonateRouting extends React.Component {
  render() {
    var regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => LANGUAGE_SHORT_CODE[key]).join('|')

    return (
      <React.Fragment>
        <MenuAppBar title={<Word wid={WID.MENU_APP_BAR.DONATE}/>}/>
        <Switch>
          <Route path={`/:language(${regstr})/donate`} component={DonatePage}/>
          <Route path={`/donate`} component={DonatePage}/>
        </Switch>
      </React.Fragment>
    )
  }
}

export default (DonateRouting)



// WEBPACK FOOTER //
// ./src/Pages/Donate/DonateRouting.js